module.exports = __webpack_public_path__ + "static/media/f1.f3357a03.jpg";